angular.module('galilai.creator').factory('visual', function ($timeout, $rootScope, fontsService) {

    window.addEventListener('touchmove', preventDefault, { passive: false });

    const USE_RELATIVE_POS = true
    const GLOBAL_ENABLED = false
    function preventDefault(e) {
        if (window._DISABLE_SCROLL) {
            e.preventDefault();
        }
    }

    function Visual(params) {
        let self = this
        if (window._VISUAL_ID) {
            window._VISUAL_ID += 1
        }  else {
            window._VISUAL_ID = 1
        }
        this.visualId = window._VISUAL_ID
        this.id = params.id
        this.editor = null
        let ACTIVE = true

        self.props = {}
        let callbacks = {}
        let currentAction = null
        let onCloseAction = null
        let selectedElement = null
        let selectedElementDOM = null
        let currentItem = null
        let settings = null
        let eventHandlers = []
        const INSERT_AT_TEXT_LEVEL = false

        let WRAPPER_SELECTOR = 'templates-wrapper'
        let GLOBAL_PARAMS = {}

        function isActive() {
            //console.log('[Visual]', uniqueId, 'isActive', ACTIVE, WRAPPER_SELECTOR)
            return ACTIVE
        }

        function waitForSelector(selector, callback) {
            let maxTries = 10
            let interval = setInterval(function () {
                if (maxTries <= 0) {
                    clearInterval(interval)
                    callback(null)
                    return
                }
                let element = document.querySelector(selector)
                if (element) {
                    clearInterval(interval)
                    callback(element)
                }
                maxTries -= 1
            }, 100)
        }

        function waitForElement(element, callback) {
            return waitForSelector(getWrapperSelector() + ' [data-id="' + element.elementId + '"][data-parent-id="' + element.cardId + '"]', callback)
        }

        function processSettings(change, cb) {
            $timeout(function () {
                if (!change || !change.cardId || !change.elementId) {
                    return
                }
                if (!settings) {
                    settings = {}
                }
                if (!settings[change.cardId]) {
                    settings[change.cardId] = {}
                }
                if (!settings[change.cardId].visual) {
                    settings[change.cardId].visual = {}
                }
                if (!settings[change.cardId].visual.elements) {
                    settings[change.cardId].visual.elements = {}
                }
                if (!settings[change.cardId].visual.elements[change.elementId]) {
                    settings[change.cardId].visual.elements[change.elementId] = {}
                }
                for (key in change.values) {
                    settings[change.cardId].visual.elements[change.elementId][key] = change.values[key]
                }
                cb()
            })
        }

        function getSelectedSettings() {
            if (!selectedElement || !settings || !settings[selectedElement.cardId] || !settings[selectedElement.cardId].visual || !settings[selectedElement.cardId].visual.elements || !settings[selectedElement.cardId].visual.elements[selectedElement.elementId]) {
                return {}
            }
            return settings[selectedElement.cardId].visual.elements[selectedElement.elementId]
        }

        function updateSelected(values) {
            if (!selectedElement) {
                return
            }
            emit('update', {
                'elementId': selectedElement.elementId,
                'pId': selectedElement.pId,
                'cardId': selectedElement.cardId,
                'values': values
            })
            // TODO
            if (values.scale) {
                selectedElementDOM.style.transform = changeScale(selectedElementDOM.style.transform, values.scale)
            }
            if (values['font-size']) {
                selectedElementDOM.style.fontSize = values['font-size']
            }
        }

        function getWrapperEl() {
            return document.querySelector(getWrapperSelector())
        }

        function getWrapperSelector() {
            return WRAPPER_SELECTOR
        }

        function emit(type, values) {
            if (type == 'render') {
                if (!callbacks.render) {
                    return
                }
                callbacks.render({
                    currentItem: currentItem,
                    id: this.id,
                    values: values
                })
            } else if (type == 'update') {
                processSettings(values, function () {
                    if (!callbacks.update) {
                        return
                    }
                    callbacks.update(values)
                })
            } else if (type == 'saveHistory') {
                if (!callbacks.onHistory) {
                    return
                }
                callbacks.onHistory(values)
            }
            else if (type == 'select') {
                if (!callbacks.select) {
                    return
                }
                selectedElement = values
                callbacks.select(values)
            } else if (type == 'deselect') {
                if (!callbacks.select) {
                    return
                }
                callbacks.deselect(values)
            }
        }

        function changeTranslate(transform, x, y) {
            let translate = transform.match(/translate\((.*)px, (.*)px\)/);
            if (translate) {
                return transform.replace(/translate\((.*)px, (.*)px\)/, `translate(${x}px, ${y}px)`);
            } else {
                return `translate(${x}px, ${y}px) ${transform}`;
            }
        }

        function getTranslate(transform) {
            let translate = transform.match(/translate\((.*)px, (.*)px\)/);
            if (translate) {
                return {
                    x: parseFloat(translate[1]),
                    y: parseFloat(translate[2])
                }
            }
            return {
                x: 0,
                y: 0
            }
        }

        function changeScale(transform, updateScale) {
            let scale = transform.match(/scale\((.*)\)/);
            if (scale) {
                return transform.replace(/scale\((.*)\)/, `scale(${updateScale})`);
            } else {
                return `${transform} scale(${updateScale})`;
            }
        }

        function removeSelectedBorder(element) {
            element.classList.remove('selected-element')
        }

        function showSelectedBorder(element) {
            if (isMovingAround)  {
                return
            }
            element.classList.add('selected-element')
        }

        /* Drag management */
        let isDragging = false;
        let allowMoveElementWhileEditing = false
        let wasDragging = false;
        let isMovingAround = false;
        let startPositionX, startPositionY;
        let deltaX = null, deltaY = null;
        let initialX = 0, initialY = 0;
        let currentDraggableElement = null;

        function withinTemplateArea(event) {
            let parent = event.target
            while (parent) {
                if (parent == getWrapperEl() || parent.id == 'visual-actions-toolbar') {
                    return true
                }
                parent = parent.parentNode
            }
            return false
        }

        function clearEvents() {
            document.removeEventListener('click', onDocumentClick);
            // Mouse events
            document.removeEventListener('mouseout', onDocumentMouseOut);
            document.removeEventListener('mousemove', drag);
            document.removeEventListener('mouseup', stopDrag);

            // Add support for touch events
            document.removeEventListener('touchend', stopDrag);
            document.removeEventListener('touchmove', drag);

            document.removeEventListener('mousemove', onResizeMouseMove);
            document.removeEventListener('mouseup', onResizeMouseUp);
            document.removeEventListener('touchmove', onResizeMouseMove);
            document.removeEventListener('touchend', onResizeMouseUp);

            try {
                for (let eventHandler of eventHandlers) {
                    // TODO - Bugged??
                    let eventName = Object.keys(eventHandler)[0]
                    let handler = eventHandler[eventName]
                    document.removeEventListener(eventName, handler);
                }
            } catch (e) {
                console.log('Error removing event handlers', e)
            }
            eventHandlers = []
        }

        function onDocumentClick(event) {
            if (!isActive()) {
                return
            }
            if (!withinTemplateArea(event)) {
                deselect()
                hideExtraActions()
            }
        }

        function onDocumentMouseOut(event) {
            if (!isActive()) {
                return
            }
            let elements = document.querySelectorAll(getWrapperSelector() + ' .selected-element')

            for (let element of elements) {
                if (element == selectedElementDOM) {
                    continue
                }
                removeSelectedBorder(element)
            }
        }

        // Start dragging
        function startDrag(element, event) {
            activeSnap = { x: null, y: null };
            if (!isActive()) {
                return
            }
            setMovingAround(element)
            // Ignore if not left click
            if (event.button && event.button != 0) {
                return
            }
            currentDraggableElement = element
            isDragging = true;
            startPositionX = getPosition(event).x;
            startPositionY = getPosition(event).y;

            // Build group
            try {
                currentGroup = null
                currentSnapElements = Array.from(document.querySelectorAll(getWrapperSelector() + ' [data-drag="true"]')).filter(el => el !== currentDraggableElement).map(el => el.getBoundingClientRect())

                let groupId = currentDraggableElement.attributes['data-groupid'] ? currentDraggableElement.attributes['data-groupid'].value : null
                // Find element where data-grouped = groupId
                if (groupId) {
                    currentGroupParent = document.querySelector(getWrapperSelector() + ' [data-grouped="' + groupId + '"]')
                    currentGroup = Array.from(document.querySelectorAll(getWrapperSelector() + ' [data-groupid="' + groupId + '"]')).filter(el => el !== currentDraggableElement)
                }
            } catch (e) {
                console.log('Error building group', e)
            }

            let elToTransform = currentDraggableElement
            if (currentGroupParent) {
                elToTransform = currentGroupParent
            }
            // Read translate x and y values of this element
            let style = elToTransform.style.transform;
            if (style) {
                let translate = style.match(/translate\((.*)px, (.*)px\)/);
                if (translate) {
                    initialX = parseInt(translate[1]);
                    initialY = parseInt(translate[2]);
                }
            } else {
                initialX = 0;
                initialY = 0;
            }
            preventScrollModal();
        }

        var SNAP_IN = 5;
        var SNAP_OUT = 8;
        var currentSnapElements = []
        var activeSnap = { x: null, y: null }; // currently snapped targets
        let currentGroup = null
        let currentGroupParent = null

        function getCurrentTransformXY(el) {
            var match = el.style.transform.match(/translate\(([-\d.]+)px,\s*([-\d.]+)px\)/);
            if (match) {
                return {
                    x: parseFloat(match[1]),
                    y: parseFloat(match[2])
                };
            }
            return { x: 0, y: 0 };
        }

        function snapToElements(deltaX, deltaY, currentElement, others) {
            var transformOffset = getCurrentTransformXY(currentElement);
            var rect = currentElement.getBoundingClientRect();
            var width = rect.width;
            var height = rect.height;

            // Subtract transform offset to get original position
            var baseLeft = rect.left - transformOffset.x;
            var baseTop = rect.top - transformOffset.y;

            var projectedLeft = baseLeft + deltaX;
            var projectedTop = baseTop + deltaY;
            var projectedRight = projectedLeft + width;
            var projectedBottom = projectedTop + height;
            var projectedCenterX = projectedLeft + width / 2;
            var projectedCenterY = projectedTop + height / 2;

            var bestSnapX = deltaX;
            var bestSnapY = deltaY;
            var closestXDiff = SNAP_OUT + 1;
            var closestYDiff = SNAP_OUT + 1;

            var snapX = null;
            var snapY = null;

            var bestXLine = null;
            var bestYLine = null;

            for (var i = 0; i < others.length; i++) {
                var other = others[i];
                var oLeft = other.left;
                var oTop = other.top;
                var oRight = oLeft + other.width;
                var oBottom = oTop + other.height;
                var oCenterX = oLeft + other.width / 2;
                var oCenterY = oTop + other.height / 2;

                var xSnapPoints = [
                    { projected: projectedLeft, target: oLeft, pos: oLeft },
                    { projected: projectedLeft, target: oRight, pos: oRight },
                    { projected: projectedCenterX, target: oCenterX, pos: oCenterX },
                    { projected: projectedRight, target: oLeft, pos: oLeft },
                    { projected: projectedRight, target: oRight, pos: oRight }
                ];

                for (var j = 0; j < xSnapPoints.length; j++) {
                    var pt = xSnapPoints[j];
                    var diff = pt.projected - pt.target;
                    var absDiff = Math.abs(diff);

                    if ((absDiff < SNAP_IN) || (activeSnap.x === pt.target && absDiff < SNAP_OUT)) {
                        if (absDiff < closestXDiff) {
                            closestXDiff = absDiff;
                            bestSnapX = deltaX - diff;
                            snapX = pt.target;
                            bestXLine = { orientation: "vertical", position: pt.pos };
                        }
                    }
                }

                var ySnapPoints = [
                    { projected: projectedTop, target: oTop, pos: oTop },
                    { projected: projectedTop, target: oBottom, pos: oBottom },
                    { projected: projectedCenterY, target: oCenterY, pos: oCenterY },
                    { projected: projectedBottom, target: oTop, pos: oTop },
                    { projected: projectedBottom, target: oBottom, pos: oBottom }
                ];

                for (var j = 0; j < ySnapPoints.length; j++) {
                    var pt = ySnapPoints[j];
                    var diff = pt.projected - pt.target;
                    var absDiff = Math.abs(diff);

                    if ((absDiff < SNAP_IN) || (activeSnap.y === pt.target && absDiff < SNAP_OUT)) {
                        if (absDiff < closestYDiff) {
                            closestYDiff = absDiff;
                            bestSnapY = deltaY - diff;
                            snapY = pt.target;
                            bestYLine = { orientation: "horizontal", position: pt.pos };
                        }
                    }
                }
            }

            activeSnap.x = snapX;
            activeSnap.y = snapY;

            var snapLines = [];
            if (bestXLine) snapLines.push(bestXLine);
            if (bestYLine) snapLines.push(bestYLine);

            return {
                x: bestSnapX,
                y: bestSnapY,
                snapLines: snapLines,
                snappedX: snapX !== null,
                snappedY: snapY !== null
            };
        }

        // Dragging in progress
        function drag(event) {
            if (!isActive()) {
                return
            }
            wasDragging = !!currentDraggableElement && isDragging
            if (!currentDraggableElement) {
                removePreventScrollModal()
                return
            }
            let elToTransform = currentDraggableElement
            if (currentGroupParent) {
                elToTransform = currentGroupParent
            }
            if (self.editor && !allowMoveElementWhileEditing) {
                return
            }
            let clientX = getPosition(event).x
            let clientY = getPosition(event).y
            if (isDragging) {
                deltaX = clientX - startPositionX + initialX
                deltaY = clientY - startPositionY + initialY
                try {
                    let snap = snapToElements(deltaX, deltaY, elToTransform, currentSnapElements)

                    deltaX = snap.x
                    deltaY = snap.y

                    renderSnapLines(snap.snapLines);
                } catch (e) {
                }
                elToTransform.style.transform = changeTranslate(elToTransform.style.transform, deltaX, deltaY)
            }
        }

        function renderSnapLines(snapLines) {
            clearSnapLines();

            var container = document.querySelector(getWrapperSelector());
            var containerRect = container.getBoundingClientRect();

            var scrollLeft = container.scrollLeft;
            var scrollTop = container.scrollTop;

            for (var i = 0; i < snapLines.length; i++) {
                var line = document.createElement("div");
                var s = line.style;

                s.position = "absolute";
                s.border = "1px dashed #00f";
                s.zIndex = 9999999999;
                s.pointerEvents = "none";

                if (snapLines[i].orientation === "vertical") {
                    // Adjust left position to container's local coordinates
                    var left = snapLines[i].position - containerRect.left + scrollLeft;
                    s.left = left + "px";
                    s.top = "0";
                    s.width = "1px";
                    s.height = container.scrollHeight + "px";
                } else {
                    // Adjust top position to container's local coordinates
                    var top = snapLines[i].position - containerRect.top + scrollTop;
                    s.top = top + "px";
                    s.left = "0";
                    s.height = "1px";
                    s.width = container.scrollWidth + "px";
                }

                line.classList.add("snap-guide-line");
                container.appendChild(line);
            }
        }

        function clearSnapLines() {
            var lines = document.querySelectorAll(".snap-guide-line");
            lines.forEach(function(line) {
                line.remove();
            });
        }

        function resetDrag() {
            removeMovingAround()
            showExtraActions(currentDraggableElement)
            isDragging = false;
            deltaX = null
            deltaY = null
            currentDraggableElement = null
            initialX = 0
            initialY = 0
            removePreventScrollModal()
        }

        // Stop dragging
        function stopDrag(event) {
            let elToTransform = currentDraggableElement
            if (currentGroupParent) {
                elToTransform = currentGroupParent
            }
            activeSnap = { x: null, y: null };
            currentGroup = null
            currentGroupParent = null
            currentSnapElements = []
            allowMoveElementWhileEditing = false

            enableScroll()
            if (!isActive()) {
                return
            }
            if (!currentDraggableElement) {
                resetDrag()
                return
            }
            if (!isDragging) {
                resetDrag()
                return
            }
            if (!isValidNumber(deltaX) || !isValidNumber(deltaY)) {
                resetDrag()
                return
            }

            let elementId = null;
            let originalId = elToTransform.attributes['data-original-id']
            if (originalId && GLOBAL_PARAMS.useOriginalIds) {
                elementId = originalId.value
            } else {
                elementId = elToTransform.attributes['data-id'].value
            }
            let cardId = elToTransform.attributes['data-parent-id'].value
            let pId = elToTransform.attributes['data-pid'] ? elToTransform.attributes['data-pid'].value : null

            emit('update', {
                'elementId': elementId,
                'pId': pId,
                'cardId': cardId,
                'values': {
                    'translate': {
                        'x': deltaX,
                        'y': deltaY,
                    }
                }
            })
            resetDrag()
        }

        function selectElement(element) {
            $timeout(function () {
                selectElementById(element)
            })
        }

        function selectElementById(element, event) {
            if (!element || !element.elementId || (typeof element.cardId == 'undefined' || element.cardId == null)) {
                return
            }
            if (selectedElementDOM) {
                removeSelectedBorder(selectedElementDOM)
                hideResizingHandles(selectedElementDOM)
            }
            let draggableElements = []

            if (GLOBAL_PARAMS.useOriginalIds) {
                draggableElements = document.querySelectorAll(getWrapperSelector() + ' [data-original-id="' + element.elementId + '"][data-parent-id="' + element.cardId + '"]')
            }
            if (!draggableElements || draggableElements.length == 0) {
                draggableElements = document.querySelectorAll(getWrapperSelector() + ' [data-id="' + element.elementId + '"][data-parent-id="' + element.cardId + '"]')
            }

            if (!draggableElements || draggableElements.length == 0) {
                return
            }
            let draggableElement = draggableElements[0]
            draggableElement.setAttribute('data-selected', 'true')

            showSelectedBorder(draggableElement)
            showResizingHandles(draggableElement)

            if (selectedElementDOM != draggableElement) {
                removeTextEditor()
            }
            // Remove text editor from previous selected element
            if (event && selectedElementDOM == draggableElement) {
                setTimeout(function () {
                    if (isDragging || isMovingAround) {
                        return
                    }
                    initTextEditor()
                    if (selectedElementDOM) {
                        selectedElementDOM.focus()
                    }
                }, 50)
            }
            selectedElementDOM = draggableElement

            emit('select', {
                'elementId': element.elementId,
                'kind': element.kind,
                'cardId': element.cardId,
            })

            closeAction()
            updateCurrentProperties()
        }


        function initTextEditor() {
            if (!isAnyText(selectedElement)) {
                return
            }
            try {
                selectedElementDOM.setAttribute('contenteditable', 'true')
                // TODO - Wait initial load
                try {
                    if (self.editor) {
                        self.editor.destroy()
                        self.editor = null
                    }
                } catch (e) {}
                self.editor = new MediumEditor(selectedElementDOM, {
                    toolbar: false,
                    placeholder: { text: '' },
                    spellcheck: false,
                });
            } catch (e) {
                console.log('Error initializing text editor', e)
            }
        }

        function removeTextEditor() {
            if (self.editor) {
                self.editor.destroy()
                self.editor = null
            }
            if (selectedElementDOM) {
                selectedElementDOM.removeAttribute('contenteditable');
                selectedElementDOM.removeAttribute('aria-multiline');
                selectedElementDOM.removeAttribute('data-medium-focused');
                selectedElementDOM.removeAttribute('data-placeholder');
                selectedElementDOM.classList.remove('medium-editor-element');
                selectedElementDOM.classList.remove('medium-editor-placeholder');
                selectedElementDOM.classList.remove('medium-editor-focus');
                selectedElementDOM.removeAttribute('data-medium-editor-element');
                selectedElementDOM.removeAttribute('data-medium-editor-editor-index');
            }
        }

        function updateCurrentProperties() {
            self.props = {}
            if (!selectedElement) {
                return
            }
            let computedStyle = window.getComputedStyle(selectedElementDOM)
            if (isAnyText(selectedElement)) {
                self.props['font-size'] = parseFloat(computedStyle.getPropertyValue('font-size'))
                self.props['color'] = normalizeToHEX(computedStyle.getPropertyValue('color'))
                try {
                    let lineHeight = computedStyle.getPropertyValue('line-height');
                    let fontSize = parseFloat(computedStyle.getPropertyValue('font-size'));
                    if (lineHeight === 'normal') {
                        self.props['line-height'] = 1.2; // or any fallback ratio you prefer
                    } else {
                        self.props['line-height'] = parseFloat(lineHeight) / fontSize;
                    }
                } catch (e) {
                    console.log('Error getting line-height', e)
                }
            }
            // Get opacity
            let currentOpacity = getValidNumber(computedStyle.getPropertyValue('opacity'), 1)
            self.props['opacity'] = currentOpacity * 100
            self.props['background-color'] = normalizeToHEX(computedStyle.getPropertyValue('background-color'))
            let settings = getSelectedSettings()
            if (settings.duration) {
                self.props['duration'] = getValidNumber(settings.duration)
            }
            try {
                self.props['border-radius'] = getValidNumber(computedStyle.getPropertyValue('border-radius'))
                self.props['border-style'] = computedStyle.getPropertyValue('border-style');
                self.props['border-width'] = getValidNumber(computedStyle.getPropertyValue('border-width'))
                self.props['border-color'] = normalizeToHEX(computedStyle.getPropertyValue('border-color'));
            } catch (e) {
            }

            $timeout(angular.noop)
        }

        function onChange(type, extraValue) {
            if(!isActive()) {
                return
            }
            if (!selectedElement) {
                return
            }

            if (type == 'font-size') {
                updateSelected({
                    'font-size': self.props['font-size'],
                    'line-height': self.props['line-height'],
                })

                selectedElementDOM.style.fontSize = self.props['font-size'] + 'px'
                selectedElementDOM.style.lineHeight = self.props['line-height']
            }
            if (type == 'font-family') {
                let fontFamily = self.props['font-family']
                if (fontFamily.indexOf('.') && (fontFamily.indexOf("'") == -1 || fontFamily.indexOf('"') == -1)) {
                    fontFamily = `"${fontFamily}"`
                }
                updateSelected({
                    'font-family': fontFamily
                })
                fontsService.loadCustomOrDefault(fontFamily, function () {
                    if (!selectedElementDOM) {
                        return
                    }
                    selectedElementDOM.style.fontFamily = fontFamily
                })
            }
            if (type == 'border-color' || type == 'border-style' || type == 'border-width') {
                let borderStyle = self.props['border-style'] || 'none'
                let borderWidth = self.props['border-width'] || 0
                let borderColor = self.props['border-color'] || '#000000'
                let borderValue = `${borderWidth}px ${borderStyle} ${borderColor}`
                updateSelected({
                    'border': borderValue
                })
                selectedElementDOM.style.border = borderValue
            }
            if (type == 'opacity') {
                updateSelected({
                    'opacity': self.props['opacity'] / 100
                })
                selectedElementDOM.style.opacity = self.props['opacity'] / 100
            }
            if (type == 'border-radius') {
                updateSelected({
                    'border-radius': self.props['border-radius'] + 'px'
                })
                selectedElementDOM.style.borderRadius = self.props['border-radius'] + 'px'
            }
            if (type == 'line-height') {
                if (isAnyText(selectedElement)) {
                    updateSelected({
                        'line-height': self.props['line-height']
                    })
                    selectedElementDOM.style.lineHeight = self.props['line-height']
                }
            }
            if (type == 'duration') {
                updateSelected({
                    'duration': self.props['duration']
                })
            }
            if (type == 'color') {
                let hasSVG = selectedElementDOM.querySelectorAll('svg').length > 0
                if (isAnyText(selectedElement)) {
                    if (!self.editor) {
                        initTextEditor()
                    }
                    if (self.editor) {
                        formatText(null, 'color', self.props['color'])
                        return
                    }
                    updateSelected({
                        'color': self.props['color']
                    })
                    selectedElementDOM.style.color = self.props['color']
                }
                else if (hasSVG) {
                    updateSelected({
                        'fill': self.props['color']
                    })
                    emit('render')
                }
                else {
                    updateSelected({
                        'background-color': self.props['color']
                    })
                    selectedElementDOM.style.backgroundColor = self.props['color']
                }
            }
        }

        function getProps() {
            return self.props
        }

        function closeAction() {
            if (onCloseAction) {
                onCloseAction()
            }
            currentAction = null
            $rootScope.$broadcast('closeAction', {
                'id': self.id
            })
        }

        function resetWrapperScroll() {
            let wrapper = getWrapperEl()
            if (!wrapper) {
                return
            }
            wrapper.scrollTop = 0
            wrapper.scrollLeft = 0
        }

        function isMobile() {
            return window.innerWidth <= 768
        }

         // Functions to disable and enable scroll
        function disableScroll() {
            window._DISABLE_SCROLL = true
        }

        function enableScroll() {
            window._DISABLE_SCROLL = false
        }

        function getPosition(event) {
            let x = 0
            let y = 0
            if (event.touches && event.touches.length > 0) {
                x = event.touches[0].clientX
                y = event.touches[0].clientY
            } else {
                x = event.clientX
                y = event.clientY
            }
            return {
                x: x,
                y: y
            }

        }
        function initDraggable() {
            let draggableElements = document.querySelectorAll(getWrapperSelector() + ' [data-drag="true"]');

            clearEvents()

            document.addEventListener('click', onDocumentClick);
            // Mouse events
            document.addEventListener('mouseout', onDocumentMouseOut);
            document.addEventListener('mousemove', drag);
            document.addEventListener('mouseup', stopDrag);

            // Add support for touch events
            document.addEventListener('touchend', stopDrag);
            document.addEventListener('touchmove', drag);

            // TODO - Needs to push to eventHandlers the correct names of the events
            eventHandlers.push({'click': onDocumentClick})
            eventHandlers.push({'mouseout': onDocumentMouseOut})
            eventHandlers.push({'mousemove': drag})
            eventHandlers.push({'mouseup': stopDrag})

            function setupObjectDrag(draggableElement) {
                let shouldDrag = true
                // Ignore main bg
                if (draggableElement.attributes['data-area'] && draggableElement.attributes['data-area'].value == 'main') {
                    shouldDrag = false
                }

                if (shouldDrag) {
                    // Mouse event listeners
                    draggableElement.addEventListener('mousedown', onMouseDown)
                    draggableElement.addEventListener('touchstart', onMouseDown, { passive: true })

                    // On mouse hover add border
                    draggableElement.addEventListener('mouseover', onMouseOver)
                    draggableElement.addEventListener('touchenter', onMouseOver)

                    draggableElement.addEventListener('mouseout' , onMouseOut)
                    draggableElement.addEventListener('touchleave', onMouseOut)
                }

                function onMouseDown(event) {
                    if (!isActive()) {
                        return
                    }
                    // Only selected on mobile
                    if (!selectedElement && isMobile()) {
                        return
                    }
                    if (draggableElement != selectedElementDOM) {
                        return
                    }
                    disableScroll()
                    startDrag(draggableElement, event)
                }

                function onMouseOver(event) {
                    if (!isActive()) {
                        return
                    }
                    draggableElement.style.cursor = 'move'
                    showSelectedBorder(draggableElement)
                }

                function onMouseOut(event) {
                    if (!isActive()) {
                        return
                    }
                    draggableElement.style.cursor = 'default'
                    // Read from data-selected attribute
                    let isSelected = false
                    if (draggableElement.attributes && draggableElement.attributes['data-selected'] && draggableElement.attributes['data-selected'].value == 'true') {
                        isSelected = true
                    }
                    if (!isSelected) {
                        removeSelectedBorder(draggableElement)
                        hideResizingHandles(draggableElement)
                    }
                }

                draggableElement.addEventListener('click', function(event) {
                    if (wasDragging) {
                        wasDragging = false
                        event.preventDefault();
                        event.stopImmediatePropagation();
                        return;
                    }
                    if (!isActive()) {
                        return
                    }
                    event.stopPropagation()

                    let elementId = null

                    let originalId = draggableElement.attributes['data-original-id']
                    if (originalId && GLOBAL_PARAMS.useOriginalIds) {
                        elementId = originalId.value
                    } else {
                        elementId = draggableElement.attributes['data-id'].value
                    }
                    let cardId = draggableElement.attributes['data-parent-id'].value
                    let pId = draggableElement.attributes['data-pid'] ? draggableElement.attributes['data-pid'].value : null
                    let params = {
                        'elementId': elementId,
                        'cardId': cardId,
                        'pId': pId,
                    }
                    // TODO - hardcoded
                    try {
                        if (draggableElement.style.backgroundImage && draggableElement.style.backgroundImage.indexOf('/videos/') != -1) {
                            params.kind = 'video'
                        }
                    } catch (e) {
                        console.log('Error detecting kind', e)
                    }

                    selectElementById(params, event)
                })

                let isOverlay = draggableElement?.attributes['data-id']?.value?.indexOf('overlay') != -1
                let isPaintable = typeof draggableElement?.attributes['data-pid'] != 'undefined' && draggableElement?.attributes['data-pid'] != null && draggableElement?.attributes['data-pid']?.value != ''
                let isText = draggableElement.tagName == 'P' || draggableElement.tagName == 'H1' || draggableElement.tagName == 'SPAN'
                if (isText) {
                    let debounceTimer = null
                    draggableElement.addEventListener('input', function(event) {
                        if (!isActive()) {
                            return
                        }
                        let elementId = draggableElement.attributes['data-id'].value
                        let cardId = draggableElement.attributes['data-parent-id'].value
                        let pId = draggableElement.attributes['data-pid'] ? draggableElement.attributes['data-pid'].value : null

                        let innerContent = draggableElement.innerHTML
                        // Remove any existing resize handles when exporting
                        innerContent = innerContent.replace(/<div class="resize-handle.*?<\/div>/g, '')

                        if (debounceTimer) {
                            clearTimeout(debounceTimer)
                        }
                        debounceTimer = setTimeout(function () {
                            emit('update', {
                                'elementId': elementId,
                                'pId': pId,
                                'cardId': cardId,
                                'values': {
                                    'content': innerContent,
                                }
                            })
                        }, 500)
                        // If Draggable element is outside getWrapperEl() bbox, then fix its width or height or both
                        let rect = draggableElement.getBoundingClientRect()
                        let wrapperRect = getWrapperEl().getBoundingClientRect()
                        if (rect.right > wrapperRect.right) {
                            draggableElement.style.width = (wrapperRect.right - rect.left) + 'px'
                        }
                    })
                    // On blur
                    draggableElement.addEventListener('blur', function(event) {
                        if (!isActive()) {
                            return
                        }
                        resetWrapperScroll()
                    })
                }
                if (shouldDrag) {
                    addResizeHandles(draggableElement)
                }
            }

            for (let draggableElement of draggableElements) {
                setupObjectDrag(draggableElement)
            }
        }

        let isResizing = false;
        let currentResizeHandle = null;
        let initialWidth = 0;
        let initialHeight = 0;
        let initialTop = 0;
        let initialLeft = 0;
        let startMouseX = 0;
        let startMouseY = 0;

        function setMovingAround() {
            isMovingAround = true
            let wrapper = getWrapperEl()
            if (!wrapper) {
                return
            }
            // Check if has class moving-around if not add
            if (!wrapper.classList.contains('moving-around')) {
                wrapper.classList.add('moving-around')
            }
        }
        function removeMovingAround() {
            isMovingAround = false
            let wrapper = getWrapperEl()
            if (!wrapper) {
                return
            }
            wrapper.classList.remove('moving-around')
        }

        function setupActions() {
            addActionsElement()
        }

        function addActionsElement() {
            let wrapper = getWrapperEl()
            if (!wrapper) {
                return
            }
            // Remove if exists
            let actions = wrapper.querySelectorAll('.el-actions')
            if (actions) {
                actions.forEach(action => action.remove())
            }
            // Create div with move (round border, white bg, dropshadow and mdi icon move)
            let content = `<div class="el-actions d-none">
                <div class="el-action move">
                    <i class="mdi mdi-cursor-move"></i>
                </div>
                <div class="el-action clone d-none">
                    <i class="mdi mdi-content-duplicate"></i>
                </div>
                <div class="el-action delete">
                    <i class="mdi mdi-delete"></i>
                </div>
            </div>`
            wrapper.insertAdjacentHTML('beforeend', content)
            // Add click listerner to move
            let moveAction = wrapper.querySelector('.el-actions .move')
            if (moveAction) {
                function onMoveMouseDown(event) {
                    disableScroll()
                    allowMoveElementWhileEditing = true
                    startDrag(selectedElementDOM, event)
                }
                moveAction.addEventListener('mousedown', onMoveMouseDown)
                moveAction.addEventListener('touchstart', onMoveMouseDown, { passive: true })
            }
            // Add click listener to clone
            let cloneAction = wrapper.querySelector('.el-actions .clone')
            if (cloneAction) {
                function cloneMouseDown(event) {
                    event.stopPropagation()
                    if (!selectedElement) {
                        return
                    }
                    cloneElement()
                }
                cloneAction.addEventListener('click', cloneMouseDown)
            }
            // Add click listener to delete
            let deleteAction = wrapper.querySelector('.el-actions .delete')
            if (deleteAction) {
                deleteAction.addEventListener('click', function (event) {
                    event.stopPropagation()
                    if (!selectedElement) {
                        return
                    }
                    removeElement()
                })
            }
        }

        function showExtraActions(element) {
            if (!element) {
                return
            }
            // Check if element has div inside with class el-actions
            let actions = element.querySelectorAll('.el-actions')
            if (actions.length > 0) {
                return
            }
            // Decide if should add el-actions-top or el-actions-bottom based on element position
            let wrapper = getWrapperEl()
            if (!wrapper) {
                return
            }
            let wrapperRect = wrapper.getBoundingClientRect()
            let elementRect = element.getBoundingClientRect()
            let style = ''
            let top = ''
            let left = ''

            // Compare top if above middle or not
            if (elementRect.top > (wrapperRect.top + wrapperRect.height / 2)) {
                // calculate left to be at center of element
                left = (elementRect.left - wrapperRect.left) + elementRect.width / 2 - 75
                top = elementRect.top - wrapperRect.top - 50
            } else {
                left = (elementRect.left - wrapperRect.left) + elementRect.width / 2 - 75
                top = elementRect.top - wrapperRect.top + elementRect.height + 10
            }
            style = `top: ${top}px; left: ${left}px;pointer-events: all!important`

            let actionElement = wrapper.querySelector('.el-actions')
            // Set style
            if (actionElement) {
                actionElement.style = style
            }
            // Remove d-none class
            if (actionElement) {
                actionElement.classList.remove('d-none')
            }
        }

        function hideExtraActions() {
            let wrapper = getWrapperEl()
            if (!wrapper) {
                return
            }
            // remove all divs with class el-actions
            let actions = wrapper.querySelectorAll('.el-actions')
            if (actions) {
                actions.forEach(action => action.classList.add('d-none'))
            }
        }

        function showResizingHandles(element) {
            const handles = element.querySelectorAll('.resize-handle');
            handles.forEach(handle => handle.style.display = 'block');
            let position = window.getComputedStyle(element).getPropertyValue('position')
            let transform = window.getComputedStyle(element).getPropertyValue('transform')
            if ((position == 'static' || !position) && (!transform || transform == 'none')) {
                element.style.position = 'relative'
                element.classList.add('relative-pos')
            }
            showExtraActions(element)
        }

        function hideResizingHandles(element) {
            const handles = element.querySelectorAll('.resize-handle');
            handles.forEach(handle => handle.style.display = 'none');
            element.classList.remove('relative-pos')
        }

        function onResizeHandleMouseDown(event) {
            if (!selectedElementDOM) {
                return
            }
            disableScroll()
            if (!isActive()) {
                return
            }
            event.stopPropagation();
            isResizing = true;
            currentResizeHandle = event.target;

            startMouseX = getPosition(event).x;
            startMouseY = getPosition(event).y;

            initialWidth = selectedElementDOM.clientWidth;
            initialHeight = selectedElementDOM.clientHeight;
            if (USE_RELATIVE_POS) {
                let translate = getTranslate(selectedElementDOM.style.transform)
                initialTop = translate?.y || 0
                initialLeft = translate?.x || 0
            } else {
                initialTop = selectedElementDOM.offsetTop;
                initialLeft = selectedElementDOM.offsetLeft;
            }
            document.addEventListener('mousemove', onResizeMouseMove);
            document.addEventListener('mouseup', onResizeMouseUp);
            document.addEventListener('touchmove', onResizeMouseMove);
            document.addEventListener('touchend', onResizeMouseUp);
        }

        function onResizeMouseMove(event) {
            if (!selectedElementDOM) {
                return
            }
            if (!isActive()) {
                return;
            }
            if (!isResizing || !currentResizeHandle) return;

            setMovingAround(selectedElementDOM)
            let deltaX = (getPosition(event).x) - startMouseX;
            let deltaY = (getPosition(event).y) - startMouseY;

            let aspectRatio = initialWidth / initialHeight;

            let newWidth = initialWidth;
            let newHeight = initialHeight;
            let newTop = null;
            let newLeft = null;

            // Corner Resizing - Keep Proportions
            if (currentResizeHandle.classList.contains('top-left')) {
                let delta = -1*Math.max(-deltaX, -deltaY); // Maintain proportion
                newWidth = initialWidth - delta;
                newHeight = newWidth / aspectRatio;
                newTop = initialTop + (initialHeight - newHeight);
                newLeft = initialLeft + (initialWidth - newWidth);
            } else if (currentResizeHandle.classList.contains('top-right')) {
                let delta = Math.min(deltaX, -deltaY); // Maintain proportion
                newWidth = initialWidth + delta;
                newHeight = newWidth / aspectRatio;
                newTop = initialTop + (initialHeight - newHeight);
            } else if (currentResizeHandle.classList.contains('bottom-left')) {
                let delta = -1*Math.max(-deltaX, deltaY); // Maintain proportion
                newWidth = initialWidth - delta;
                newHeight = newWidth / aspectRatio;
                newLeft = initialLeft + (initialWidth - newWidth);
            } else if (currentResizeHandle.classList.contains('bottom-right')) {
                let delta = Math.min(deltaX, deltaY); // Maintain proportion
                newWidth = initialWidth + delta;
                newHeight = newWidth / aspectRatio;
            }

            // Middle Handle Resizing - Only Single Direction
            if (currentResizeHandle.classList.contains('middle-top')) {
                newHeight = initialHeight - deltaY;
                newTop = initialTop + deltaY;
            } else if (currentResizeHandle.classList.contains('middle-bottom')) {
                newHeight = initialHeight + deltaY;
            } else if (currentResizeHandle.classList.contains('middle-left')) {
                newWidth = initialWidth - deltaX;
                newLeft = initialLeft + deltaX;
            } else if (currentResizeHandle.classList.contains('middle-right')) {
                newWidth = initialWidth + deltaX;
            }

            // Ensure new dimensions are valid
            if (newWidth > 1 && newHeight > 1) {
                selectedElementDOM.style.width = newWidth + 'px';
                selectedElementDOM.style.height = newHeight + 'px';

                if (USE_RELATIVE_POS) {
                    if (newTop !== null || newLeft !== null) {
                        selectedElementDOM.style.transform = changeTranslate(selectedElementDOM.style.transform, newLeft !== null ? newLeft : initialLeft, newTop !== null ? newTop : initialTop);
                    }
                } else {
                    if (newTop !== null) {
                        selectedElementDOM.style.top = newTop + 'px';
                    }
                    if (newLeft !== null) {
                        selectedElementDOM.style.left = newLeft + 'px';
                    }
                }
            }
        }

        function resetResize() {
            removeMovingAround()
            isResizing = false;
            currentResizeHandle = null;
            document.removeEventListener('mousemove', onResizeMouseMove);
            document.removeEventListener('mouseup', onResizeMouseUp);
            document.removeEventListener('touchmove', onResizeMouseMove);
            document.removeEventListener('touchend', onResizeMouseUp);
        }

        function onResizeMouseUp(event) {
            enableScroll();
            if (selectedElementDOM) {
                showExtraActions(selectedElementDOM)
            }
            if (!isActive()) {
                return
            }
            if (!currentResizeHandle) {
                resetResize();
                return;
            }
            removeMovingAround()
            isResizing = false;
            currentResizeHandle = null;

            if (selectedElementDOM) {
                let params = {
                    'elementId': selectedElement.elementId,
                    'pId': selectedElement.pId,
                    'cardId': selectedElement.cardId,
                    'values': {
                        'width': selectedElementDOM.style.width,
                        'height': selectedElementDOM.style.height,
                        'left': selectedElementDOM.style.left,
                        'top': selectedElementDOM.style.top
                    }
                }
                if (USE_RELATIVE_POS) {
                    let translate = getTranslate(selectedElementDOM.style.transform)
                    params.values['translate'] = translate
                }
                emit('update', params);
            }

            resetResize();
        }

        function addResizeHandles(draggableElement) {
            // First remove all existing handles
            const existingHandles = draggableElement.querySelectorAll('.resize-handle');
            existingHandles.forEach(handle => handle.remove());

            // Add resizing handles
            const handles = ['top-left', 'top-right', 'bottom-left', 'bottom-right', 'middle-top', 'middle-right', 'middle-bottom', 'middle-left'];
            handles.forEach(handle => {
                const resizeHandle = document.createElement('div');
                resizeHandle.classList.add('resize-handle', handle);
                resizeHandle.style.display = 'none'; // Initially hidden
                draggableElement.appendChild(resizeHandle);

                resizeHandle.addEventListener('mousedown', onResizeHandleMouseDown);
                resizeHandle.addEventListener('touchstart', onResizeHandleMouseDown, { passive: true })
            });
        }

        function addVisualSetting(theme, id, settings) {
            settings= fullcopy(settings)
            if (!theme.settings) {
                theme.settings = {}
            }
            if (!theme.settings[id]) {
                theme.settings[id] = {}
            }
            if (!theme.settings[id].visual) {
                theme.settings[id].visual = {}
            }
            if (!theme.settings[id].visual.elements) {
                theme.settings[id].visual.elements = {}
            }
            for (let key in settings) {
                theme.settings[id].visual.elements[key] = settings[key]
            }
        }

        function removeVisualElementsWithPrefix(currentItem, theme, prefixId, exactId = false) {
            let cardId = currentItem.id
            let item = currentItem.item
            try {
                if (theme.settings[cardId] && theme.settings[cardId].visual && theme.settings[cardId].visual.elements) {
                    for (let key in theme.settings[cardId].visual.elements) {
                        if (exactId && key == prefixId) {
                            delete theme.settings[cardId].visual.elements[key]
                        } else if (!exactId && key.startsWith(prefixId)) {
                            delete theme.settings[cardId].visual.elements[key]
                        }
                    }
                }
            } catch (e) {
                console.log('Error removing visual elements', e)
            }

            // Filter based on prefix
            if (item.overlays && item.overlays.elements) {
                item.overlays.elements = item.overlays.elements.filter(function (element) {
                    if (exactId) {
                        return element.uniqueId.toString() != prefixId
                    } else {
                        return !element.uniqueId.toString().startsWith(prefixId)
                    }
                })
            }
        }

        // TODO - wrong
        function replaceOverlays(selectedItem, overlay, prefixId) {
            let selectedItemId = selectedItem.id
            let newItem = fullcopy(selectedItem.item)
            let newTheme = fullcopy(selectedItem.theme)

            // TODO - Replace initial?
            let tempId = 1
            if (!newItem.overlays) {
                newItem.overlays = {}
            }
            if (!newItem.overlays.elements) {
                newItem.overlays.elements = []
            }

            // TODO - wrong, should pass selectedItem
            removeVisualElementsWithPrefix(newItem, newTheme, prefixId)

            for (element of overlay.elements) {
                let elementItem = {
                    type: 'overlay',
                    value: element.content,
                    uniqueId: prefixId + tempId,
                }
                let styleItem = {}

                // TODO - Style
                element.style.fill = 'text'
                element.style['opacity'] = '0.4'

                styleItem[prefixId + tempId] = element.style
                addVisualSetting(newTheme, id = selectedItemId, styleItem)

                newItem.overlays.elements.push(elementItem)
                tempId += 1
            }
            return {
                item: newItem,
                theme: newTheme
            }
        }

        function resetVisualLayout(theme, id, options) {
            if (!theme.settings) {
                return
            }
            if (!theme.settings[id]) {
                return
            }
            if (!theme.settings[id].visual) {
                return
            }
            if (!theme.settings[id].visual.elements) {
                return
            }
            for (let key in theme.settings[id].visual.elements) {
                if (options.exclude && options.exclude.indexOf(key) > -1) {
                    continue
                }
                delete theme.settings[id].visual.elements[key]
            }
            emit('saveHistory')
        }

        function generateRandomUUID(prefix) {
            const characters = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
            let uuid = "";

            for (let i = 0; i < 10; i++) {
                const randomIndex = Math.floor(Math.random() * characters.length);
                uuid += characters.charAt(randomIndex);
            }

            return `${prefix}-${uuid}`;
        }

        function moveElementsUp() {
            // TODO - Check this (Update z-index of other elements)
            try {
                for (let elementKey in currentItem.theme.settings[currentItem.id].visual.elements) {
                    let element = currentItem.theme.settings[currentItem.id].visual.elements[elementKey]
                    if (elementKey.indexOf('overlay') == -1) {
                        continue
                    }
                    if (element['z-index']) {
                        element['z-index'] = parseInt(element['z-index']) + 1
                    }
                }
            } catch (e) {
                console.log('Error updating z-index', e)
            }
        }

        function getZIndexToInsert() {
            let allElements = document.querySelectorAll(getWrapperSelector() + ' [data-drag="true"]')
            let textElement = document.querySelector(getWrapperSelector() + ' [data-original-id="text"]')
            if (textElement && INSERT_AT_TEXT_LEVEL) {
                return textElement.style.zIndex
            }
            let zIndex = 0
            for (let element of allElements) {
                if (element.style.zIndex > zIndex) {
                    zIndex = element.style.zIndex
                }
            }
            return parseInt(zIndex)
        }

        function addElement(content) {
            deselect()

            function removePaddingFromSVG(svgString) {
                let parentElement = document.createElement('div')
                parentElement.id = 'temp-svg'
                parentElement.innerHTML = svgString
                parentElement.style.visibility = 'hidden'
                document.body.appendChild(parentElement)

                let bb = document.querySelector('#temp-svg svg').getBBox()
                svgElement = document.querySelector('#temp-svg svg')

                let newSvgString = svgString

                let currentViewBox = svgElement.getAttribute('viewBox')
                if (currentViewBox) {
                    let currentBB = currentViewBox.split(' ')
                    if (bb.width < currentBB[2] && bb.height < currentBB[3]) {
                        svgElement.setAttribute('viewBox', `${bb.x} ${bb.y} ${bb.width} ${bb.height}`)
                        newSvgString = parentElement.innerHTML
                    }
                }
                document.body.removeChild(parentElement)
                return newSvgString
            }

            content = removePaddingFromSVG(content)

            if (!currentItem) {
                return
            }
            if (!currentItem.item.overlays) {
                currentItem.item.overlays = {}
            }
            if (!currentItem.item.overlays.elements) {
                currentItem.item.overlays.elements = []
            }

            let maxId = 0
            for (element of currentItem.item.overlays.elements) {
                let id = element.uniqueId.match(/\d+/)
                if (id) {
                    id = parseInt(id[0])
                    if (id > maxId) {
                        maxId = id
                    }
                }
            }
            let uniqueId = generateRandomUUID('overlay')
            currentItem.item.overlays.elements.push({
                type: 'overlay',
                value: content,
                uniqueId: uniqueId,
            })

            let zIndex = getZIndexToInsert()
            let newSetting = {}
            newSetting[uniqueId] = {
                position: 'absolute',
                top: '10px',
                left: '10px',
                width: '80px',
                height: '80px',
                fill: 'text',
                'z-index': zIndex,
            }

            addVisualSetting(currentItem.theme, id = currentItem.id, newSetting)
            moveElementsUp()

            emit('saveHistory')
            emit('render')
            track('Visual Action', {
                'action': 'Add Element',
            })
        }

        // generic add widget
        function addWidget(widget) {
            widget = fullcopy(widget)
            if (!widget) {
                return
            }
            if (!currentItem) {
                return
            }
            if (!currentItem.item.overlays) {
                currentItem.item.overlays = {}
            }
            if (!currentItem.item.overlays.elements) {
                currentItem.item.overlays.elements = []
            }
            let uniqueId = generateRandomUUID(widget.type) + '-overlay'
            widget.uniqueId = uniqueId
            currentItem.item.overlays.elements.push(widget)

            let zIndex = getZIndexToInsert() + 1
            let newSetting = {}
            newSetting[uniqueId] = {
                position: 'absolute',
                top: (100 + Math.floor(Math.random() * 80)) + 'px',
                left: (50 + Math.floor(Math.random() * 80)) + 'px',
                'z-index': zIndex,
            }

            addVisualSetting(currentItem.theme, id = currentItem.id, newSetting)
            moveElementsUp()
            emit('saveHistory')
            emit('render')
        }

        function addText(kind, text) {
            if (!text) {
                text = '     '
            }
            if (!currentItem) {
                return
            }
            if (!currentItem.item.overlays) {
                currentItem.item.overlays = {}
            }
            if (!currentItem.item.overlays.elements) {
                currentItem.item.overlays.elements = []
            }

            let uniqueId = generateRandomUUID('p') + '-overlay'
            currentItem.item.overlays.elements.push({
                type: kind,
                subtype: 'overlay',
                color: 'text',
                value: text,
                uniqueId: uniqueId,
            })

            let zIndex = getZIndexToInsert() + 1
            let newSetting = {}
            newSetting[uniqueId] = {
                position: 'absolute',
                top: '50px',
                left: '50px',
                'font-size': kind == 'h1' ? '2rem' : '0.75rem',
                'z-index': zIndex,
            }

            addVisualSetting(currentItem.theme, id = currentItem.id, newSetting)
            moveElementsUp()

            emit('saveHistory')
            emit('render')
            track('Visual Action', {
                'action': 'Add Text',
            })
            let newElement = {
                elementId: uniqueId,
                cardId: currentItem.id
            }
            $timeout(function () {
                waitForElement(newElement, function(element) {
                    selectElement(newElement)
                    $timeout(function () {
                        element.click()
                        $timeout(function () {
                            element.focus()
                            if (!self.editor) {
                                return
                            }
                            self.editor.execAction('selectAll')
                        }, 50)
                    }, 100)
                })
            })
        }

        function getImageAspectRatio(imageUrl, callback) {
            const img = new Image();

            img.onload = function() {
            const width = img.width;
            const height = img.height;
            const aspectRatio = width / height;
            callback(null, {
                width,
                height,
                aspectRatio
            });
            }

            img.onerror = function() {
                callback(new Error('Image load error'));
            };

            img.src = imageUrl;
        }

        function addImage(image) {
            if (!image) {
                return
            }
            if (!currentItem) {
                return
            }

            if (!currentItem.item.image) {
                currentItem.item.image = image
                emit('saveHistory')
                emit('render')
                return
            }

            if (!currentItem.item.overlays) {
                currentItem.item.overlays = {}
            }
            if (!currentItem.item.overlays.elements) {
                currentItem.item.overlays.elements = []
            }

            getImageAspectRatio(image, function(err, spec) {
                if (err) {
                    console.error('Error loading image', err)
                    return
                }
                let uniqueId = generateRandomUUID('image') + '-overlay'
                currentItem.item.overlays.elements.push({
                    type: 'image',
                    subtype: 'overlay',
                    src: image,
                    uniqueId: uniqueId,
                })

                let baseWidth = 120
                let width = baseWidth
                let height = baseWidth / spec.aspectRatio

                let zIndex = getZIndexToInsert() + 1
                let newSetting = {}
                newSetting[uniqueId] = {
                    position: 'absolute',
                    top: '10px',
                    left: '10px',
                    width: width + 'px',
                    height: height + 'px',
                    'z-index': zIndex,
                }

                addVisualSetting(currentItem.theme, id = currentItem.id, newSetting)
                moveElementsUp()

                emit('saveHistory')
                emit('render')
                track('Visual Action', {
                    'action': 'Add Image',
                })
            });
        }

        function cloneElement() {
            if (!selectedElement) {
                return
            }
            if (!currentItem) {
                return
            }
            if (!currentItem.item.overlays) {
                currentItem.item.overlays = {}
            }
            if (!currentItem.item.overlays.elements) {
                currentItem.item.overlays.elements = []
            }

            // This is bugged, need to get actual layout
            let existingEl = getElementById(currentItem?.parsedLayout?.elements, selectedElement.elementId)
            if (!existingEl) {
                console.log('Error: Element to clone not found', selectedElement.elementId, currentItem)
                return
            }
            let foundEl = JSON.parse(JSON.stringify(existingEl))
            let uniqueId = generateRandomUUID(foundEl.type) + '-overlay'
            foundEl.uniqueId = uniqueId
            currentItem.item.overlays.elements.push(foundEl)
            delete foundEl['$$hashKey']
            delete foundEl.id
            delete foundEl.visible
            delete foundEl.attrs

            let newSetting = {}
            newSetting[uniqueId] = fullcopy(currentItem?.theme?.settings[currentItem.id]?.visual?.elements[selectedElement.elementId])
            if (!newSetting[uniqueId]) {
                newSetting[uniqueId] = {}
            }
            // Offset position by 20px (using transform (check if exists))
            let currentTop = 0
            let currentLeft = 0
            let translate = getTranslate(selectedElementDOM.style.transform)
            if (translate) {
                currentTop = translate.y
                currentLeft = translate.x
            }
            // Update transform
            newSetting[uniqueId].transform = changeTranslate(selectedElementDOM.style.transform, currentLeft + 20, currentTop + 20)
            if (!newSetting[uniqueId]['z-index']) {
                newSetting[uniqueId]['z-index'] = 0
            }
            newSetting[uniqueId]['z-index'] = parseInt(newSetting[uniqueId]['z-index']) + 1
            // Update position
            addVisualSetting(currentItem.theme, id = currentItem.id, newSetting)
            moveElementsUp()

            emit('saveHistory')
            emit('render')
        }

        function isOverlay(element) {
            return element.elementId.indexOf('overlay') != -1
        }

        function removeElement(settings) {
            if (isOverlay(selectedElement)) {
                removeVisualElementsWithPrefix(currentItem, currentItem.theme, selectedElement.elementId, exactId = true)
            } else {
                let newSetting = {}
                newSetting[selectedElement.elementId] = {
                    display: 'none',
                }
                addVisualSetting(currentItem.theme, id = currentItem.id, newSetting)
            }
            emit('saveHistory')
            emit('render')
            track('Visual Action', {
                'action': 'Remove Element'
            })
            deselect()
        }

        function replaceImage(settings, url) {
            if (currentItem?.layout?.mutant) {
                let newSetting = {}
                newSetting[selectedElement.elementId] = {
                    'background-image': `url(${url})`,
                    'background-size': 'cover',
                    'background-position': 'center',
                    'background-repeat': 'no-repeat',
                }
                addVisualSetting(currentItem.theme, id = currentItem.id, newSetting)
            }
            else if (isOverlay(selectedElement)) {
                let overlay = currentItem?.item?.overlays?.elements.find(function (element) {
                    return element.uniqueId == selectedElement.elementId
                })
                if (!overlay) {
                    return
                }
                overlay.src = url
            } else {
                currentItem.item.image = url
            }
            emit('saveHistory')
            emit('render')

            track('Visual Action', {
                'action': 'Replace Image'
            })
        }

        function replaceFont(settings, font) {
            self.props['font-family'] = font
            onChange('font-family')
        }
        let rangeSelection = null
        function saveSelection() {
            const sel = window.getSelection();
            return sel.rangeCount > 0 ? sel.getRangeAt(0).cloneRange() : null;
        }

        function restoreSelection(range) {
            if (range) {
                const sel = window.getSelection();
                sel.removeAllRanges();
                sel.addRange(range);
            }
        }

        function restoreTextSelection() {
            if (rangeSelection) {
                restoreSelection(rangeSelection)
            }
        }

        function formatText(settings, type, value) {
            const selection = window.getSelection();
            if (!self.editor) {
                initTextEditor()
            }
            if (selection.rangeCount > 0 && selection.isCollapsed) {
                var range = document.createRange();

                // Select all the content in the editor
                range.selectNodeContents(selectedElementDOM);

                // Clear any existing selection and add the new range
                selection.removeAllRanges();
                selection.addRange(range);
            }

            if (type == 'bold') {
                self.editor.execAction('bold')
            } else if (type == 'italic') {
                self.editor.execAction('italic')
            }
            else if (type == 'color') {
                self.editor.execAction('foreColor', {
                    value: value,
                })
            }
            rangeSelection = saveSelection()
        }

        function alignText(settings, type) {
            selectedElementDOM.style.textAlign = type
            updateSelected({
                'text-align': type
            })
            track('Visual Action', {
                'action': 'Align Text'
            })
        }

        function deselect() {
            clearSnapLines()
            closeAction();
            enableScroll();
            if (!selectedElementDOM) {
                removePreventScrollModal()
                return
            }
            removeTextEditor()
            removeSelectedBorder(selectedElementDOM)
            hideResizingHandles(selectedElementDOM)
            selectedElementDOM = null
            emit('deselect', selectedElement)
            selectedElement = null
            preventScrollModal();
        }

        function preventScrollModal() {
            let modalDialog = document.querySelector('#layouts-modal')
            if (!modalDialog) {
                return
            }
            modalDialog.classList.add('is-dragging')
        }

        function removePreventScrollModal() {
            let modalDialog = document.querySelector('#layouts-modal')
            if (!modalDialog) {
                return
            }
            modalDialog.classList.remove('is-dragging')
        }

        function moveUp(settings) {
            let zIndex = selectedElementDOM.style.zIndex
            selectedElementDOM.style.zIndex = parseInt(zIndex) + 1
            updateSelected({
                'z-index': parseInt(zIndex) + 1
            })
            track('Visual Action', {
                'action': 'Move Up'
            })
        }

        function toggleHideOverlay() {
            settings[currentItem.id].hideOverlay = !settings[currentItem.id].hideOverlay
            emit('saveHistory')
            emit('render')
        }

        function moveDown(settings) {
            let zIndex = selectedElementDOM.style.zIndex
            if (zIndex <= 0) {
                return
            }
            selectedElementDOM.style.zIndex = parseInt(zIndex) - 1
            updateSelected({
                'z-index': parseInt(zIndex) - 1
            })
            track('Visual Action', {
                'action': 'Move Down'
            })
        }

        function bringToFront() {
            // TODO
            track('Visual Action', {
                'action': 'Bring To Front'
            })
        }

        function sendToBack() {
            selectedElementDOM.style.zIndex = 0
            updateSelected({
                'z-index': 0
            })
            track('Visual Action', {
                'action': 'Send To Back'
            })
        }

        function isTextOverlay(element) {
            // TODO - review this when there is a widget. I dont think this is used anymore
            return (element.elementId.indexOf('p-') == 0 || element.elementId.indexOf('h1-') == 0) && element.elementId.indexOf('overlay') != -1
        }

        function decreaseSize(settings) {
            if (isTextOverlay(selectedElement)) {
                decreaseFont(settings)
                return
            }
            let scale = settings.scale || 1
            if (scale <= 0.2) {
                return
            }
            updateSelected({
                scale: scale - 0.1
            })
            track('Visual Action', {
                'action': 'Decrease Size'
            })
        }

        function increaseSize(settings) {
            if (isTextOverlay(selectedElement)) {
                increaseFont(settings)
                return
            }
            let scale = settings.scale || 1
            updateSelected({
                scale: scale + 0.1
            })
            track('Visual Action', {
                'action': 'Increase Size'
            })
        }

        function decreaseFont(settings) {
            let fontSize = parseFloat(settings['font-size'] || '1rem')
            if (fontSize <= 0.2) {
                return
            }
            updateSelected({
                'font-size': fontSize - 0.1 + 'rem'
            })
            track('Visual Action', {
                'action': 'Decrease Font Size'
            })
        }

        function increaseFont(settings) {
            let fontSize = parseFloat(settings['font-size'] || '1rem')
            updateSelected({
                'font-size': fontSize + 0.1 + 'rem'
            })
            track('Visual Action', {
                'action': 'Increase Font Size'
            })
        }

        function isKind(kind) {
            return selectedElement.elementId.indexOf(kind + '-') == 0
        }

        function destroy() {
            ACTIVE = false
            clearEvents()
        }

        function getSelectedElement() {
            return selectedElement
        }

        function getElementById(elements, elementId) {
            if (!elementId) {
                return null
            }
            if (!elements) {
                return null
            }
            for (let element of elements) {
                if (element.id == elementId) {
                    return element
                }
                if (element.elements) {
                    let found = getElementById(element.elements, elementId)
                    if (found) {
                        return found
                    }
                }
            }
            return null
        }

        let exports = {
            getProps: getProps,
            getSettings: function () {
                return self.settings
            },
            currentAction: currentAction,
            onCloseAction: onCloseAction,
            getElementById: getElementById,
            getSelected: getSelectedElement,
            getSelectedElement: getSelectedElement,
            replaceOverlays: replaceOverlays,
            addVisualSetting: addVisualSetting,
            selectElement: selectElement,
            deselectElement: deselect,
            resetVisualLayout: resetVisualLayout,
            addElement: addElement,
            addWidget: addWidget,
            addText: addText,
            addImage: addImage,
            isKind: isKind,
            destroy: destroy,
            init: init,
            destroy: destroy,
            onChange: onChange,
        }

        let userActions = [
            "moveUp",
            "moveDown",
            "bringToFront",
            "sendToBack",
            "removeElement",
            "formatText",
            "alignText",
            "decreaseSize",
            "increaseSize",
            "deselect",
            "replaceImage",
            "replaceFont",
            "toggleHideOverlay",
            "restoreTextSelection"
        ]
        for (let action of userActions) {
            exports[action] = function (...args) {
                if (!selectedElement) {
                    return
                }
                // Call action with settings
                let settings = getSelectedSettings()
                let fn = eval(action)
                fn(settings, ...args)
            }
        }

        function isAnyText(element) {
            return isText(element) || isSpan(element)
        }

        function isText(element) {
            return element?.elementId?.indexOf('p-') == 0 || element?.elementId?.indexOf('h1-') == 0
        }

        function isSpan(element) {
            return element?.elementId?.indexOf('span-') == 0
        }

        function addGlobalHandlers() {
            if (!GLOBAL_ENABLED) {
                return
            }
            function moveWithArrows(event) {
                // Micro adjustment with arrows
                let mapKeyToAction = {
                    37: 'left',
                    38: 'up',
                    39: 'right',
                    40: 'down',
                }
                if (mapKeyToAction[event.keyCode] && selectedElement) {
                    event.preventDefault()
                    event.stopPropagation()

                    let currentTranslate = getTranslate(selectedElementDOM.style.transform)

                    let hDelta = 0
                    let vDelta = 0

                    if (mapKeyToAction[event.keyCode] == 'left') {
                        hDelta = -1
                    }
                    if (mapKeyToAction[event.keyCode] == 'right') {
                        hDelta = 1
                    }
                    if (mapKeyToAction[event.keyCode] == 'up') {
                        vDelta = -1
                    }
                    if (mapKeyToAction[event.keyCode] == 'down') {
                        vDelta = 1
                    }

                    hDelta = currentTranslate.x + hDelta
                    vDelta = currentTranslate.y + vDelta

                    selectedElementDOM.style.transform = changeTranslate(selectedElementDOM.style.transform, hDelta, vDelta)
                    updateSelected({
                        'translate': {
                            'x': hDelta,
                            'y': vDelta,
                        }
                    })
                }
            }
            // Setup for backspace
            function globalKeydownListener(event) {
                if (event.keyCode == 8) {
                    if (selectedElement && !isAnyText(selectedElement)) {
                        removeElement()
                    }
                }
                //moveWithArrows(event)
            }
            document.addEventListener('keydown', globalKeydownListener)
            eventHandlers.push({'keydown': globalKeydownListener})
        }

        function init(cbs, currentItemToUpdate, params) {
            if (!cbs) {
                cbs = {}
            }
            callbacks = cbs
            // Bind this for each callback
            for (let key in callbacks) {
                if (typeof callbacks[key] == 'function') {
                    callbacks[key] = callbacks[key].bind(self)
                }
            }
            settings = currentItemToUpdate.theme.settings
            currentItem = currentItemToUpdate
            WRAPPER_SELECTOR = params && params.wrapperSelector ? params.wrapperSelector : WRAPPER_SELECTOR
            GLOBAL_PARAMS = params || {}

            setupActions()
            initDraggable()
            addGlobalHandlers()
        }

        return exports
    }

    return Visual
})